import { Component, Input, OnInit } from '@angular/core';
import {
  config,
  MemberDetails,
  MemberQuery,
  PopulationQuery,
  MixedLoyaltyItem,
  MixedLoyaltyQuery,
  MixedLoyaltyItemType,
  AnnouncementService,
} from '@fgb/core';
import { firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  config = config;
  @Input() take?: number;
  memberDetails$: Observable<MemberDetails | undefined>;
  populations = Populations;
  isCorporate: boolean;
  isJuniorBluebird: boolean;
  mixedLoyaltyItems$: Observable<MixedLoyaltyItem[]>;

  constructor(
    public memberQuery: MemberQuery,
    private populationQuery: PopulationQuery,
    private mixedLoyaltyService: MixedLoyaltyQuery,
    private announcementService: AnnouncementService
  ) {}
  
  ngOnInit() {
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    firstValueFrom(this.announcementService.fetchAnnouncements());
    this.isCorporate = this.populationQuery.userInPopulation([this.populations.Hospitality]);
    this.isJuniorBluebird = this.populationQuery.userInPopulation([this.populations.JuniorBluebirds]);

    this.mixedLoyaltyItems$ = this.mixedLoyaltyService
      .selectFavouriteMixedLoyaltyItems(true, [MixedLoyaltyItemType.Lotto, MixedLoyaltyItemType.Marketplace])
      .pipe(map((items) => items.slice(0, this.take)));
  }
}
